module.exports = __webpack_public_path__ + "e6342c0c26e6a4eb03889bfe4ef1def6.ttf";